export default __webpack_public_path__ + "static/media/three-wheeler.04b75281.svg";